import CollectionsIcon from "@mui/icons-material/Collections";
import EuroSymbolIcon from "@mui/icons-material/EuroSymbol";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";


export const storeFrontMenuEntries = [
  { label: "Compune", href: "/comanda", icon: ShoppingCartIcon },
  { label: "Galeria Amintirilor", href: "/amintiri", icon: CollectionsIcon },
  { label: "Prețuri", href: "/preturi", icon: EuroSymbolIcon },
];
